import styled from 'styled-components'

export const StateRoot = styled.section.attrs({})`
  display: flex;
  width: 100%;
  min-height: 240px;
  padding: clamp(28px, 5vw, 48px);
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 20px;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
`

export const StateTitle = styled.h2.attrs({})`
  margin: 0;
  font-family: Gilroy;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 700;
  line-height: 1.15;
  color: ${p => p.theme.palette.colors.text};
`

export const StateDescription = styled.p.attrs({})`
  max-width: 620px;
  margin: 0 0 10px;
  font-family: Poppins;
  font-size: 16px;
  line-height: 1.6;
  color: ${p => p.theme.palette.colors.muted};
`
